import { useState } from "react";
import { AssignmentTurnedIn } from "@mui/icons-material";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { navigateFromClick } from "shared/services/navigationClick";
import { useMyWorkCount } from "../hooks/useMyWorkCount";
import { MyWorkPopover } from "./MyWorkPopover";

export function MyWorkButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    const { count } = useMyWorkCount();
    const total = count.data?.total || 0;
    return <>
        <Tooltip title={t("my_work.title")}><IconButton color="inherit"
            aria-label={String(t("my_work.button_label", { count: total }))}
            onClick={event => {
                if (event.ctrlKey || event.metaKey) navigateFromClick(event, navigate, "/home/workspace/my-work");
                else setAnchor(event.currentTarget);
            }}
            onAuxClick={event => { if (event.button === 1) navigateFromClick(event, navigate, "/home/workspace/my-work"); }}>
            <Badge badgeContent={total} max={99} invisible={total === 0} color="error"><AssignmentTurnedIn /></Badge>
        </IconButton></Tooltip>
        <MyWorkPopover anchor={anchor} onClose={() => setAnchor(null)} />
    </>;
}
